import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Form, Input, Spin } from 'antd';
import { setOtpVerifiedEmailAction } from 'common/commonRedux/auth/actions';
import { useAxiosRequest, useIsDark } from 'common/hooks';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
interface countDown {
  countdown: number;
  initialCountdown: number;
  isDisabled: boolean;
}

import SelectedPlanBanner from 'modules/auth/signUp/SelectedPlanBanner';
import topPic from './topPic.png';
import logo from './logo.png';
const OtpVerify = () => {
  const isDark = useIsDark();
  const [countDown, setCountDown] = useState<countDown>({
    countdown: 45,
    initialCountdown: 45,
    isDisabled: true,
  });
  const email = useSelector((state: any) => state.auth?.profileData?.optEmail);
  const dispatch: any = useDispatch();
  const verifyOtp = useAxiosRequest(null);
  const resendOtp = useAxiosRequest(null);
  const [form] = Form.useForm();

  useEffect(() => {
    if (countDown.countdown > 0) {
      const timer = setInterval(() => {
        setCountDown((prev) => ({
          ...prev,
          countdown: prev.countdown - 1,
        }));
      }, 1000);

      return () => clearInterval(timer);
    } else {
      setCountDown((prev) => ({
        ...prev,
        isDisabled: false,
      }));
    }
  }, [countDown.countdown]);

  const handleResendOtp = () => {
    resendOtp.apiAction({
      urlObjKey: 'SendOtpforVerifyEmail',
      params: { email },
      method: 'POST',
      isToast: true,
      // errorMessage: 'Something wrong to send the OTP',
      cb: () => {
        // message.success('OTP resend successfully!');
        setCountDown((prev) => ({
          countdown: prev.initialCountdown + 45,
          initialCountdown: prev.initialCountdown + 45,
          isDisabled: true,
        }));
      },
      onError: (error) => {
        console.error('Otp send fail:', error);
      },
    });
  };

  const onFinish = (values: any) => {
    const otp = values?.otp;
    verifyOtp.apiAction({
      urlObjKey: 'VerifyOtp',
      params: { email, otp },
      method: 'POST',
      isToast: true,
      // successMessage: 'OTP verification successful!',
      // errorMessage: 'Your OTP is wrong',
      cb: () => {
        dispatch(setOtpVerifiedEmailAction(email));
        form.resetFields();
      },
      onError: (error) => {
        console.error('OTP verification failed:', error);
      },
    });
  };

  return (
    <div className="w-full">
      <div className=" w-full flex flex-col justify-center items-center gap-4 pb-6">
        <img
          src={logo}
          alt="Trackforce Logo"
          className="w-[120px] object-contain "
        />
        <h1
          className={`text-2xl font-semibold ${isDark ? 'text-white' : 'text-[#334155]'}`}
        >
          Verify OTP
        </h1>
        <SelectedPlanBanner isDark={isDark} />
      </div>
      <div className="w-full">
        <div className="my-5 space-y-1">
          <h3 className="text-xl text-center">
            An OTP has been sent to{' '}
            <span className="font-medium text-green-600">{email}</span>
          </h3>
        </div>
        <Form form={form} onFinish={onFinish} autoComplete="off">
          <div className="flex flex-col justify-center items-center mb-3 space-y-2">
            <p className="text-xl font-semibold">Enter OTP</p>
            <Form.Item
              name="otp"
              rules={[
                { required: true, message: 'Please enter the OTP!' },
                {
                  len: 4,
                  message: 'OTP must be 4 characters long.',
                },
              ]}
            >
              <Input.OTP
                size="large"
                length={4}
                onChange={(e: any) =>
                  form.setFieldsValue({
                    otp: e.target.value,
                  })
                }
                className={`h-14 !w-14 text-2xl font-semibold border-2 hover:border-primaryColor/30 focus:border-primaryColor focus:shadow-primaryColor/20 rounded-lg transition-all ${isDark ? 'border-[#2E3138]' : 'border-gray-200'}`}
              />
            </Form.Item>
          </div>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              size="large"
              className="w-full !bg-primaryColor !text-white"
              loading={verifyOtp.isLoading}
              iconPosition="end"
            >
              {verifyOtp.isLoading ? 'Verifying' : 'Verify OTP'}
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="text-center mt-6">
        <div
          className={`text-sm ${isDark ? 'text-[#94A3B8]' : 'text-gray-500'}`}
        >
          {resendOtp.isLoading ? (
            <Spin
              indicator={<LoadingOutlined className="text-primaryColor" />}
            />
          ) : (
            <button
              onClick={handleResendOtp}
              disabled={countDown.isDisabled}
              className={`inline-flex items-center gap-2 ${
                countDown.isDisabled
                  ? isDark
                    ? 'text-[#64748B] cursor-not-allowed'
                    : 'text-gray-400 cursor-not-allowed'
                  : 'text-primaryColor hover:text-primaryColor/80 transition-colors'
              }`}
            >
              <ReloadOutlined className="align-middle" />
              <span>Resend OTP</span>
              {countDown.isDisabled && (
                <span
                  className={`ml-1 ${isDark ? 'text-[#64748B]' : 'text-gray-400'}`}
                >
                  ({countDown.countdown}s)
                </span>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OtpVerify;
